import {createAsyncThunk, createSelector, createSlice} from "@reduxjs/toolkit";
import httpRequest from "../../services/httpRequest";
import AppUtil from "../../utilities/AppUtil";

// Main URL Endpoint
const _prefix = "/accreditation";

export const fetchAccreditationPaging = createAsyncThunk(
    "accreditation/fetchAccreditationPaging",
    async (params) => {
        const result = await httpRequest({
            url: `${_prefix}/page`,
            method: "GET",
            params: AppUtil.toSnakeCaseKey(params),
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const fetchAccreditationDetail = createAsyncThunk(
    "accreditation/fetchAccreditationDetail",
    async (params) => {
        const result = await httpRequest({
            url: `${_prefix}/detail/${params}`,
            method: "GET",
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const reduceCreateAccreditation = createAsyncThunk(
    "accreditation/reduceCreateAccreditation",
    async (params) => {
        const result = await httpRequest({
            url: `${_prefix}`,
            method: "POST",
            data: AppUtil.toSnakeCaseKey(params),
            successMessage: 'toast.create.200'
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const reduceUpdateAccreditation = createAsyncThunk(
    "accreditation/reduceUpdateAccreditation",
    async (data) => {
        const result = await httpRequest({
            url: `${_prefix}/update/${data.id}`,
            method: "PUT",
            data: AppUtil.toSnakeCaseKey(data.params),
            successMessage: 'toast.update.200'
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const reduceDeleteAccreditation = createAsyncThunk(
    "accreditation/reduceDeleteAccreditation",
    async (params) => {
        const result = await httpRequest({
            url: `${_prefix}/delete`,
            method: "DELETE",
            data: AppUtil.toSnakeCaseKey(params),
            successMessage: 'toast.remove.200'
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);


const initialState = {
    list: [],
    detail: {}
};

const slice = createSlice({
    name: "accreditation",
    initialState: initialState,
    reducers: {
    },
    extraReducers: {
        [fetchAccreditationPaging.fulfilled]: (state, {payload}) => {
            if (payload) {
                state.list = payload.content;
            }
        },
        [fetchAccreditationDetail.fulfilled]: (state, {payload}) => {
            if (payload) {
                state.detail = payload;
            }
        }
    }
});

const { reducer } = slice;
export default reducer;

export const getAccreditationPagingList = createSelector(
    state => state.accreditation.list,
    list => list
)

export const getAccreditationDetail = createSelector(
    state => state.accreditation.detail,
    detail => detail
)
